export default {
  nodeCard: {
    fill: 'rgb(4, 62, 92)',
    fillOpacity: 1,
    cursor: 'pointer',
    rx: '2',
    ry: '2',
  },
  nodeNameText: {
    fontSize: '15px',
    fontWeight: 'bold',
    fill: 'white',
    fillOpacity: 1,
    x: '15px',
    y: '30px',
  },
  nodeMessageTextCell: {
    fill: 'white',
    rx: '10',
    ry: '10',
    x: '0px',
  },
  nodeMessageText: {
    x: '15px',
    y: '25px',
  },
  endCell: {
    strokeWidth: '1',
    fill: '#F7F8F9',
    stroke: '#CECED4',
    rx: '2',
    ry: '2',
  },
  edgeButtonCell: {
    fill: 'white',
    rx: '10',
    ry: '10',
  },
  edgeButtonCellFolded: {
    rx: '10',
    ry: '10',
    fill: 'rgba(120,120,120, 0.7)',
  },
  edgeButtonText: {
    x: '15px',
    y: '25px',
    fontWeight: '100',
  },
};



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/styles/GraphSVGElements.js